import { useMemo } from "react";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import type { FlatRowSelectOption } from "web_myplann/Shared/Components/FlatRow/FlatRowSelect";

type EnumValue = string | number;

type LabelMap<TValue extends EnumValue> = Record<TValue, string>;

export const useEnumSelectOptions = <TEnum extends Record<string, EnumValue>>(
	enumObject: TEnum,
	labelResources: LabelMap<TEnum[keyof TEnum]>,
	excludeValues: TEnum[keyof TEnum][] = [],
): FlatRowSelectOption<TEnum[keyof TEnum]>[] => {
	const { t } = useResource();
	const excludeKey = excludeValues.join("|");

	return useMemo(
		() =>
			(Object.values(enumObject) as TEnum[keyof TEnum][])
				.filter((value) => !excludeValues.includes(value))
				.map((value) => ({
					value,
					label: t(labelResources[value]),
				})),
		[enumObject, labelResources, t, excludeKey],
	);
};
